module.exports = __webpack_public_path__ + "h5/img/ltpamss@2x.539f4e56.png";